var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBullseyeSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 480 480",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M326.33,0H480V153.67A255.71,255.71,0,0,0,326.33,0ZM153.67,0H0V153.67A255.71,255.71,0,0,1,153.67,0ZM326.33,480H480V326.33A255.71,255.71,0,0,1,326.33,480ZM0,326.33V480H153.67A255.71,255.71,0,0,1,0,326.33Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M240,3C109.11,3,3,109.11,3,240S109.11,477,240,477,477,370.89,477,240,370.89,3,240,3Zm0,434C131.2,437,43,348.8,43,240S131.2,43,240,43s197,88.2,197,197S348.8,437,240,437Z",
    opacity: 0.95
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M240,85A155,155,0,1,0,395,240,155,155,0,0,0,240,85Zm0,279A124,124,0,1,1,364,240,124,124,0,0,1,240,364Z",
    opacity: 0.75
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M240,170a70,70,0,1,0,70,70A70,70,0,0,0,240,170Zm0,123a53,53,0,1,1,53-53A53,53,0,0,1,240,293Z",
    opacity: 0.45
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBullseyeSquare);
export default __webpack_public_path__ + "static/media/BullseyeSquare.a5f42ca07ad22c2581f02b1c41ce1db4.svg";
export { ForwardRef as ReactComponent };